import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SoftBox from "../SoftBox";
import SoftTypography from "../SoftTypography";
import { useTranslation } from "react-i18next";

export const FileUploadBox = ({ onFileSelected, selectedFile, isMultiple }) => {
    const { t } = useTranslation(['common']);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        multiple: isMultiple,
        onDrop: (acceptedFiles) => {
            if (acceptedFiles.length > 0) {
                onFileSelected(isMultiple ? acceptedFiles : acceptedFiles[0]);
            }
        }
    });

    return (
        <SoftBox
            {...getRootProps()}
            p={3}
            border="1px dashed"
            borderColor="info.main"
            borderRadius="lg"
            textAlign="center"
            sx={{
                cursor: "pointer",
                backgroundColor: isDragActive ? "#e3f2fd" : "#f9f9f9",
                transition: "background-color 0.3s ease-in-out",
            }}
        >
            <input {...getInputProps()} />
            <CloudUploadIcon color="info" fontSize="large" />
            <SoftTypography mt={1} color="text">
                {selectedFile.length > 0
                    ? isMultiple
                        ? t("fileUploadBox.selectedFiles", {number: selectedFile.length})
                        : t("fileUploadBox.selected", {name: selectedFile.name})
                    : isDragActive
                        ? t("fileUploadBox.dropFile")
                        : t("fileUploadBox.drag&drop")
                }
            </SoftTypography>
        </SoftBox>
    );
};

FileUploadBox.propTypes = {
    onFileSelected: PropTypes.func.isRequired,
    selectedFile: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.instanceOf(File)),
        PropTypes.arrayOf(PropTypes.object),
    ]),
    isMultiple: PropTypes.bool,
};